// extracted by mini-css-extract-plugin
export default {"aboutModule":"_1682a5f6","aboutModuleInner":"_485575e8","aboutColumn":"_9e6c20da","paragraphText":"_e5b6d272"};